import {ListItem} from "@domain/common/list-view/list-item";

/**
 * Modèle d'item de la liste des frais de mission
 */
export class FraisMissionListeItem implements ListItem {
    /** Identifiant du taux */
    idTaux: number;
    /** Libellé du territoire */
    libelleTerritoire: string;
    /** Libellé du pays (pour les villes) */
    libellePays: string;
    /** Code ISO2 du pays (pour le drapeau) */
    codeIso: string;
    /** Type de territoire : pays, ville, zone, territoire */
    typeTerritoire: string;
    /** Libellé du taux spécial */
    libelleSpecial: string;
    /** Libellés des domaines concatenés */
    libellesDomaines: string;
    /** Période minimum */
    periodeMin: number;
    /** Période maximum */
    periodeMax: number;
    /** Date d'application formatée */
    dateApplication: string;
    /** Indicateur taux spécial */
    hasTauxSpecial: boolean;
    /** Indicateur parent */
    isParent: boolean;
    /** Liste des enfants */
    enfants: FraisMissionListeItem[];
    /** État déplié/replié */
    isExpanded: boolean = false;

    /**
     * Constructeur
     */
    constructor(data?: Partial<FraisMissionListeItem>) {
        Object.assign(this, data);
        //Mapping du champ "parent" sérialisé
        this.isParent = (data as any)?.parent ?? false;
        //Mapping des enfants en instances de FraisMissionListeItem
        if (data?.enfants) {
            this.enfants = data.enfants.map((e: any) => new FraisMissionListeItem(e));
        }
    }

    /**
     * Retourne la clé de l'élément
     */
    getKey(): number {
        return this.idTaux;
    }

    /**
     * Titre complet (territoire + taux spécial)
     */
    getTitreComplet(): string {
        let titre = this.libelleTerritoire || '';
        if (this.libellePays) {
            titre += ', ' + this.libellePays;
        }
        if (this.libelleSpecial) {
            titre += ' - ' + this.libelleSpecial;
        }
        return titre;
    }

    /**
     * Données de période pour traduction
     */
    getPeriodeData(): { key: string; params?: { min: number; max?: number } } | null {
        if (this.periodeMin && this.periodeMax) {
            return {
                key: 'admin.frais.indemnites.fraisMissions.liste.periodeMinMax',
                params: { min: this.periodeMin, max: this.periodeMax }
            };
        }
        if (this.periodeMin) {
            return {
                key: this.periodeMin === 1
                    ? 'admin.frais.indemnites.fraisMissions.liste.periodeMinEtPlusSingulier'
                    : 'admin.frais.indemnites.fraisMissions.liste.periodeMinEtPlus',
                params: { min: this.periodeMin }
            };
        }
        return null;
    }

    /**
     * Indique si on doit afficher un drapeau (pays ou ville)
     */
    hasDrapeau(): boolean {
        return (this.typeTerritoire === 'pays' || this.typeTerritoire === 'ville') && !!this.codeIso;
    }

    /**
     * Bascule l'état déplié/replié
     */
    toggleExpand(): void {
        this.isExpanded = !this.isExpanded;
    }
}